import React, { useState } from 'react';
import { Target, Clock, AlertTriangle, List } from 'lucide-react';
import ExtractionAccuracyTab from './ExtractionAccuracyTab';
import CSREffortTab from './CSREffortTab';
import ERPGapsTab from './ERPGapsTab';
import SessionLogTab from './SessionLogTab';

const TABS = [
  { id: 'accuracy', label: 'Extraction Accuracy', icon: Target },
  { id: 'effort', label: 'CSR Effort', icon: Clock },
  { id: 'gaps', label: 'A+ Gaps', icon: AlertTriangle },
  { id: 'sessions', label: 'Session Log', icon: List },
];

export default function DashboardTabs() {
  const [activeTab, setActiveTab] = useState('accuracy');

  return (
    <div>
      {/* Tab Bar */}
      <div className="flex gap-1 mb-6 bg-slate-800/50 rounded-lg p-1 w-fit">
        {TABS.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-slate-700 text-white shadow-sm'
                  : 'text-slate-400 hover:text-white hover:bg-slate-700/50'
              }`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      {activeTab === 'accuracy' && <ExtractionAccuracyTab />}
      {activeTab === 'effort' && <CSREffortTab />}
      {activeTab === 'gaps' && <ERPGapsTab />}
      {activeTab === 'sessions' && <SessionLogTab />}
    </div>
  );
}
